import { Alert } from "@mui/material";
import useAlert from "./useAlert";

const AlertPopup = () => {
    const { text, type } = useAlert();

    if (text && type) {
        return (
            <Alert
                severity={type}
                role={type === "error" ? "alert" : "status"}
                aria-live={type === "error" ? "assertive" : "polite"}
                sx={{
                    position: 'fixed',
                    zIndex: 99999,
                    top: "10%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                }}
            >
                {text}
            </Alert>
        );
    } else {
        return <></>;
    }
};

export default AlertPopup;
